import React from "react";
import "./Professions.css";
import iconReact from "./icon-react.png";
import iconCloud from "./cloud.png";
import icontIOT from "./icon-iot.jpg";

const Professions = () => {
  return(
    <div id="professions-body">
      <div id="professions-container">
        <div id="professions-header">Our Solutions</div>
        <div id="professions-sub-header">We are a modern software development group that makes cloud native applications, specializing in React.js & React Native.</div>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-4">
              <div className="professions-box-size-color" data-aos="zoom-in">
                <div className="professions-box-header">
                  <img className="cloudSize" src={iconCloud}/>
                  <div className="professions-box-title">Cloud</div>
                </div>
                <p className="professions-box-body text-left">We specialize in cloud based computing and can help your business integrate into the cloud or architect your own cloud-based infastructure.  Whether you are looking to minimize costs for servers and data centers or increase the speed of your operation, we can help you get there. </p>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-4">
              <div className="professions-box-size-color" data-aos="zoom-in">
                <div className="professions-box-header">
                    <img src={iconReact}/>
                  <div className="professions-box-title">React.js</div>
                </div>
                <p className="professions-box-body text-left">Our team is comprised of an international group of React.js and React Native developers.  React based applications are faster, scalable, and easier to interpret. While this is our speciality, we will work with your company's unique needs to architect your perfect application.</p>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-4">
              <div className="professions-box-size-color" data-aos="zoom-in">
                <div className="professions-box-header">
                  <img src={icontIOT}/>
                  <div className="professions-box-title">I.O.T.</div>
                </div>
                <p className="professions-box-body text-left">I.O.T. or the Internet of Things is no longer a thing of the future.  We understand the need to connect and scale your business with efficiency.  Whether you want to integrate business processes, analyze or act on new data, or improve decision making within your business, we've got you covered. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Professions;



// WEBPACK FOOTER //
// ./src/components/Services/Professions/Professions.js